import img1 from "../../assets/carLogos/bmw-logo.svg";
import img2 from "../../assets/carLogos/bmw-mini.svg";
import img3 from "../../assets/carLogos/corvette-logo.svg";
import img4 from "../../assets/carLogos/jeep.svg";
import img5 from "../../assets/carLogos/mercedes-benz.svg";
import img6 from "../../assets/carLogos/porsche.svg";
import img7 from "../../assets/carLogos/seat.svg";
import img8 from "../../assets/carLogos/volkswagen.svg";

const logos = [
	{ id: 1, src: img1 },
	{ id: 2, src: img2 },
	{ id: 3, src: img3 },
	{ id: 4, src: img4 },
	{ id: 5, src: img5 },
	{ id: 6, src: img6 },
	{ id: 7, src: img7 },
	{ id: 8, src: img8 },
];

const LogoItem = ({ src, alt }) => (
	<div className="group overflow-hidden rounded-lg bg-white/10 p-1 shadow-lg hover:bg-white/20 transition duration-300 ease-in-out">
		<img
			src={src}
			alt={alt}
			className="w-full h-auto object-contain transform group-hover:scale-110 transition duration-500 ease-in-out"
		/>
	</div>
);

export default function LogosSection() {
	return (
		<div className="w-full bg-[#001d3b] py-5 px-2 sm:px-6 lg:px-10">
			<div className="grid grid-cols-4 gap-2 md:grid-cols-6 lg:grid-cols-8 lg:gap-4">
				{logos.map((logo, index) => (
					<LogoItem
						key={index}
						src={logo.src}
						alt={`Logo de la marca del coche ${index + 1}`}
					/>
				))}
			</div>
		</div>
	);
}
